<template>
  <div>
    <div class="container">
      <div>
        <el-switch v-model="enableDeliverKind4" active-text="开启叫号堂食" />
        <span style="font-size:12px;color:#999999;"> 用户扫描通用小程序码下单, 并等待商家叫号</span>
      </div>
      <div style="height: 10px;"></div>
      <div>
        <el-switch v-model="enableDeliverKind3" active-text="开启桌号堂食" />
        <span style="font-size:12px;color:#999999;"> 用户扫描桌面小程序码下单, 并等待商家上菜</span>
      </div>
    </div>
    <div class="container">
      <el-dropdown @command="cmd => (kind = cmd)">
        <span class="el-dropdown-link" style="font-weight:bold;">
          {{ { general: '通用小程序码', desk: '桌号小程序码' }[kind] }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="general">通用小程序码</el-dropdown-item>
          <el-dropdown-item command="desk">桌号小程序码</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="container">
      <div class="setting-minqr">
        <!-- 桌号堂食 -->
        <div v-if="kind == 'desk'" class="table-eatin">
          <div class="table-eatin-left">
            <div class="table-eatin-left-desc">效果预览</div>
            <img crossorigin="anonymous" class="table-eatin-left-qrcode" src="../../../assets/images/qrcode-preview.png" />
            <img crossorigin="anonymous" class="table-eatin-left-qrcode-qr" :src="minqr || ''" />
            <div class="table-eatin-left-desc">
              下载物料进行打印，建议尺寸
              <span class="mark">8cm * 10cm</span>张贴至桌角方便用户扫码点餐
            </div>
          </div>
          <div class="table-eatin-right">
            <div class="table-eatin-right-qrcode-box">
              <el-form label-position="left" label-width="80px">
                <el-form-item label="桌号">
                  <el-input size="small" v-model="row.name"></el-input>
                </el-form-item>
                <el-form-item label="小程序码">
                  <el-button size="small" @click="add" type="primary">生成</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="table-eatin-right-qrcode-box" v-for="item in list" :key="item.id">
              <el-form label-position="left" label-width="80px">
                <el-form-item label="桌号">
                  <span>{{ item.name }}</span>
                  <i class="el-icon-delete table-eatin-right-qrcode-box-icon" @click="del(item)"></i>
                </el-form-item>
                <el-form-item label="小程序码">
                  <img :data-name="item.name" crossorigin="anonymous" class="js-table-qrcode table-eatin-right-miniqrcode" :src="item.qr" />
                </el-form-item>
              </el-form>
            </div>
          </div>

          <div class="download">
            <div style="position: fixed; left: 10000px;">
              <img crossorigin="anonymous" ref="qrcodebg" src="../../../assets/images/qrcode-bg.png" alt />
            </div>
            <el-button type="primary" @click="downloadTableQr">下载</el-button>
          </div>
        </div>
        <!-- 通用 -->
        <div v-if="kind == 'general'" class="call-number">
          <div class="call-number-left">
            <div class="table-eatin-right-header-left">
              <div class="table-eatin-right-header-left-content">
                <img crossorigin="anonymous" style="width:200px;height:200px;" :src="minqr || ''" />
              </div>
              <div class="table-eatin-left-desc" style="margin-top: 10px;">此小程序码可以自行下载打印, 张贴到店内醒目位置, 用户扫码进行<span class="mark">叫号堂食</span>; 也可用于发单, 地推等宣传推广. (小程序上线后才可显示)</div>
            </div>
          </div>
          <div class="call-number-right">
            <img crossorigin="anonymous" class="call-number-poster" src="../../../assets/images/callnumber-poster-preview.png" />
            <img crossorigin="anonymous" class="call-number-poster-qr" :src="minqr || ''" />
          </div>
          <div class="download">
            <div style="position: fixed; left: 10000px;">
              <img ref="qrcodebg" crossorigin="anonymous" src="../../../assets/images/callnumber-poster-bg.png" alt />
              <img ref="qrcode" crossorigin="anonymous" :src="minqr || ''" alt />
            </div>
            <el-button type="primary" @click="downloadPoster">下载</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
import JSZip from 'jszip';
import uploadFile from '../../../components/uploadFile/index.vue';
import { getCachedStore } from '../../../router/auth.js';

export default {
  name: 'setting-minqr',
  components: {
    'upload-file': uploadFile
  },
  data() {
    return {
      token: getToken(),
      store: {},
      enableDeliverKind3: false,
      enableDeliverKind4: false,
      kind: 'general', // or desk
      minqr: '',
      row: {
        name: '',
        qr: ''
      },
      list: []
    };
  },
  watch: {
    enableDeliverKind3(v) {
      if (this.enableDeliverKind3) {
        if (this.enableDeliverKind4) {
          this.enableDeliverKind4 = false;
        }
      }
      this.updateStore();
    },
    enableDeliverKind4(v) {
      if (this.enableDeliverKind4) {
        if (this.enableDeliverKind3) {
          this.enableDeliverKind3 = false;
        }
      }
      this.updateStore();
    }
  },
  async mounted() {
    rpc('StoreAuthService.GetStore', M('Token', { token: this.token })).then(res => {
      this.store = res;
      this.enableDeliverKind3 = this.store.deliverkindlistList.includes(3);
      this.enableDeliverKind4 = this.store.deliverkindlistList.includes(4);
    });
    rpc(
      'StoreMinQrService.GetMinQrList',
      M('MinQrListQueryRequest', {
        token: M('Token', { token: this.token }),
        count: 100
      })
    ).then(res => {
      this.list = res.minqrlistList;
    });
    this.store = await getCachedStore();
    rpc(
      'StoreQrService.GetQr',
      M('StoreQrServiceGetQrRequest', {
        token: M('Token', { token: this.token }),
        path: 'pages/home/home?StoreID=' + this.store.id
      })
    ).then(res => {
      this.minqr = res.url;
    });
  },
  methods: {
    updateStore() {
      const params = JSON.parse(JSON.stringify(this.store));
      if (this.enableDeliverKind3 && !params.deliverkindlistList.includes(3)) {
        params.deliverkindlistList.push(3);
      }
      if (!this.enableDeliverKind3 && params.deliverkindlistList.includes(3)) {
        params.deliverkindlistList = params.deliverkindlistList.filter(v => v !== 3);
      }
      if (this.enableDeliverKind4 && !params.deliverkindlistList.includes(4)) {
        params.deliverkindlistList.push(4);
      }
      if (!this.enableDeliverKind4 && params.deliverkindlistList.includes(4)) {
        params.deliverkindlistList = params.deliverkindlistList.filter(v => v !== 4);
      }
      rpc(
        'StoreStoreService.UpdateInfo',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...params,
            businesshoursList: params.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: params.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      ).then(res => {
        this.store = res;
      });
    },
    async add() {
      console.log('pages/home/home?StoreID=' + this.store.id + '&desk=' + encodeURIComponent(this.row.name));
      const res = await rpc(
        'StoreQrService.GetQr',
        M('StoreQrServiceGetQrRequest', {
          token: M('Token', { token: this.token }),
          path: 'pages/home/home?StoreID=' + this.store.id + '&desk=' + encodeURIComponent(this.row.name)
        })
      );
      this.row.qr = res.url;
      const res1 = await rpc(
        'StoreMinQrService.CreateMinQr',
        M('MinQrWithTokenRequest', {
          token: M('Token', { token: this.token }),
          minqr: M('MinQr', this.row)
        })
      );
      this.list.splice(0, 0, res1);
    },

    async del(row) {
      const res = await rpc(
        'StoreMinQrService.DeleteMinQr',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: row.id
        })
      );
      this.list.splice(this.list.findIndex(v => v.id == row.id), 1);
    },

    //合成下载等一系例函数
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    downloadTableQr() {
      const images = document.querySelectorAll('.js-table-qrcode');

      for (let i = 0; i < images.length; i += 1) {
        if (!images[i].complete) {
          this.$message('小程序码还未加载完成，请稍后重试');
        }
      }

      const zip = new JSZip();
      const arr = Array.prototype.slice.call(images).map(item => {
        return {
          bg: this.$refs.qrcodebg,
          qr: item
        };
      });

      arr.forEach((item, index) => {
        const n = item.qr.dataset.name;
        const c = this.combineTableQrcode({ bg: item.bg, qr: item.qr });
        const s = c.toDataURL('image/png');
        zip.file(`${n}.png`, s.substr(s.indexOf(',') + 1), { base64: true });
      });

      zip.generateAsync({ type: 'blob' }).then(content => {
        const u = URL.createObjectURL(content);
        this.download('minapp.zip', u);
      });
    },
    downloadPoster() {
      if (!this.minqr) {
        this.$message('还没有小程序');
        return;
      }

      if (!this.$refs.qrcode.complete) {
        this.$message('小程序码还未加载完成，请稍后重试');
        return;
      }

      const c = this.combinePoster({ bg: this.$refs.qrcodebg, qr: this.$refs.qrcode });
      const u = URL.createObjectURL(this.dataURLtoBlob(c.toDataURL('image/png')));

      this.download('minapp.png', u);
    },
    combineTableQrcode(obj) {
      const n = obj.qr.dataset.name;
      const c = document.createElement('canvas');
      const ctx = c.getContext('2d');

      c.width = 1050;
      c.height = 1275;

      ctx.drawImage(obj.bg, 0, 0, 500, 600);
      ctx.drawImage(obj.qr, 125, 195, 250, 250);

      if (n.length > 4) {
        ctx.font = '34px Arial';
        ctx.fontWeight = 1500;
        ctx.fillStyle = '#fff';
        ctx.fillText(`${n}`, 23, 557);
      } else {
        ctx.font = '50px Arial';
        ctx.fontWeight = 1500;
        ctx.fillStyle = '#fff';
        ctx.fillText(`${n}`, 23, 560);
      }

      return c;
    },
    combinePoster(obj) {
      const c = document.createElement('canvas');
      const ctx = c.getContext('2d');

      c.width = 2000;
      c.height = 2800;

      ctx.drawImage(obj.bg, 0, 0, 2000, 2800);
      ctx.drawImage(obj.qr, 1373, 2025, 530, 530);

      return c;
    },
    download(name, url) {
      const a = document.createElement('a');
      a.download = name;
      a.href = url;
      a.click();
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-minqr {
  min-height: calc(100vh - 160px);
  display: flex;
  padding-top: 50px;
  align-items: flex-start;
  justify-content: center;
  padding-bottom: 150px;
}
// 叫号堂食
.call-number {
  align-self: center;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.call-number-left {
  width: 320px;
}
.call-number-right {
  margin-left: 50px;
  width: 320px;
  position: relative;
}
.call-number-poster {
  width: 350px;
  height: 490px;
  background-color: #f5f5f5;
  z-index: 1;
}
.call-number-poster-qr {
  position: absolute;
  width: 96px;
  height: 96px;
  top: 352px;
  left: 238px;
  z-index: 2;
}

// 桌号堂食
.table-eatin {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.table-eatin-left {
  width: 320px;
  position: relative;
}
.table-eatin-left-desc {
  color: #666;
  line-height: 1.5;
}
.table-eatin-left-qrcode {
  border: 1px solid #e8e8e8;
  margin: 10px 0;
  width: 320px;
  height: 400px;
}
.table-eatin-left-qrcode-qr {
  height: 160px;
  width: 160px;
  position: absolute;
  top: 160px;
  left: 80px;
}
.mark {
  color: #ff4f4f;
}
.table-eatin-right {
  margin-left: 100px;
}
.table-eatin-right-header {
  display: flex;
  justify-content: space-between;
}
.table-eatin-right-header-left-content {
  width: 200px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.table-eatin-right-header-left-desc {
  color: #999;
}
.table-eatin-qrcode-img-comment {
  line-height: 1.5;
  margin-top: 10px;
  color: #999;
  margin-left: 10px;
}
.table-eatin-right-header-right {
  margin-left: 35x;
}
.table-eatin-right-qrcode-box .el-form-item {
  margin-bottom: 5px;
}
.table-eatin-right-miniqrcode {
  width: 120px;
  height: 120px;
  background-color: #f5f5f5;
  border: 1px solid #e8e8e8;
}
.table-eatin-right-qrcode-box {
  margin-top: 10px;
  border: 1px solid #e8e8e8;
  padding: 15px;
  position: relative;
}
.table-eatin-right-qrcode-box-icon {
  display: none;
  padding: 5px;
  position: absolute;
  top: 8px;
  right: 0;
  cursor: pointer;
}
.table-eatin-right-qrcode-box:hover .table-eatin-right-qrcode-box-icon {
  display: block;
}
.table-eatin-right-add-qrcode {
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #e8e8e8;
  margin-top: 10px;
  cursor: pointer;
}

.download {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  padding: 0 25px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
